import { render, staticRenderFns } from "./GraficoPizzaMarketingTickets.vue?vue&type=template&id=b045fc80"
import script from "./GraficoPizzaMarketingTickets.vue?vue&type=script&lang=js"
export * from "./GraficoPizzaMarketingTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports